// extracted by mini-css-extract-plugin
module.exports = {"coaches":"CoachesList_coaches__2UYcV","coach":"CoachesList_coach__3YAgC","fadeIn":"CoachesList_fadeIn__3E8lL"};